import { render } from "./VersionDropdown.vue?vue&type=template&id=72221582"
import script from "./VersionDropdown.vue?vue&type=script&lang=js"
export * from "./VersionDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__